// Whether anybody is at the window (dioxus-plan.md D1114).
//
// The chat's round buttons stand over the feed, and over a feed being read and
// not touched they are only in the way. So the page says when nothing has come
// from the reader for a moment: `data-idle` on the root, down again at the next
// movement or key. What it hides is the stylesheet's (`.chat-float` in `app.css`).
//
// An attribute on the root, for the reason `motion.js` keeps attributes: both
// clients' renderers own `class` and `style` and rewrite them whole.
//
// Shared by both clients for the reason `ink.js` is (D57): the desktop inlines
// it into the head of every window, the web imports it at the entry.
(function () {
  "use strict";

  if (typeof window === "undefined" || window.__echoIdle) return;

  var AFTER_MS = 3000;
  var IDLE = "data-idle";
  var root = document.documentElement;

  // The newest activity and one timer that reads it, not a timer per event: a
  // moving pointer is a hundred events a second.
  var last = 0;
  var waiting = false;

  // Ctrl held down sends nothing more, and the keys it shows stand on the
  // controls it is showing them for (docs/tooltips-plan.md D741).
  function held() {
    return typeof window.__echoKeytips === "object" && window.__echoKeytips !== null && window.__echoKeytips.up();
  }

  function check() {
    var left = last + AFTER_MS - Date.now();
    if (left > 0 || held()) {
      setTimeout(check, left > 0 ? left : AFTER_MS);
      return;
    }
    waiting = false;
    root.setAttribute(IDLE, "");
  }

  function active(event) {
    // Layout changing under a resting pointer can raise a move that went
    // nowhere, and a message landing is not somebody at the window.
    if (event && event.type === "pointermove" && event.movementX === 0 && event.movementY === 0) return;
    last = Date.now();
    if (waiting) return;
    waiting = true;
    root.removeAttribute(IDLE);
    setTimeout(check, AFTER_MS);
  }
  window.__echoIdle = active;

  // Capture, so that no handler below can stop any of it from being heard. Not
  // `scroll`: a feed following its newest message scrolls with nobody there.
  var from = ["pointermove", "pointerdown", "keydown", "wheel", "touchmove"];
  for (var i = 0; i < from.length; i++) {
    document.addEventListener(from[i], active, { capture: true, passive: true });
  }
  active();
})();
